import React from 'react';
/**
 * @ignore - internal component.
 */

var TableContext = React.createContext();
export default TableContext;